import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { getReferrerCode } from "@/lib/referral";

const SKEY = "affinity.sid";
const UKEY = "affinity.utm";
export const getSession = () => {
  let s = sessionStorage.getItem(SKEY);
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem(SKEY, s); }
  return s;
};
export const getUtm = () => { try { return JSON.parse(sessionStorage.getItem(UKEY) || "{}"); } catch (_) { return {}; } };
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

export function useTracking() {
  const { pathname, search } = useLocation();
  const last = useRef("");
  useEffect(() => {
    if (pathname.startsWith("/admin") || pathname.startsWith("/go/")) return;
    const key = pathname + search;
    if (last.current === key) return;
    last.current = key;
    const params = new URLSearchParams(search);
    const utm = Object.fromEntries(UTM_KEYS.map((k) => [k, params.get(k) || null]));
    if (!sessionStorage.getItem(UKEY)) sessionStorage.setItem(UKEY, JSON.stringify({ ...utm, landing_referrer: document.referrer?.slice(0, 300) || null, landing_path: pathname }));
    const first = getUtm();
    api.post("/track", { path: pathname, session: getSession(), ref: params.get("ref") || getReferrerCode() || null, link: params.get("l") || null, referrer: document.referrer?.slice(0, 300) || null, ...Object.fromEntries(UTM_KEYS.map((k) => [k, utm[k] || first[k] || null])) }).catch(() => {});
  }, [pathname, search]);
}
